import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSt: CultureInfo = {
  name: 'st',
  displayName: 'Southern Sotho',
  iso3LanguageCode: 'sot',
  iso2LanguageCode: 'st',
  ietfLanguageTag: 'st',
  parent: null
};
